import {Navigate, useLocation} from "react-router-dom";
import StorageHelper from "../common/StorageHelper";

const PrivateRoute = ({children}: { children: JSX.Element }) => {
    const user = StorageHelper.getUser()
    let location = useLocation();

    if (!user["cognito:groups"].includes("Admins")) {
        return <Navigate to="/" state={{from: location}} replace/>;
    }
    return children;
}

export default PrivateRoute;
